import { isEmpty, omit } from 'ramda'
import { useFilter } from '@btime/react-contexts'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import {
  HideOnFullScreen,
  ShowOnFullScreen
} from '../../../packages/kiti/components/helpers/fullScreen/FullScreenHelpers'
import { useDashActiveTab } from './tabs/_helpers'
import { useForm, useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useFullScreenState } from '../../../packages/kiti/components/helpers/fullScreen/FullScreenContext'
import { useOpenSelectWidgetTypeModal } from '../../../utils/routes/modals/modalsActions'
import Button from '../../../packages/kiti/components/actions/Button'
import FiltersBar from './filters/FiltersBar'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconButton from '../../../packages/kiti/components/actions/IconButton'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Line from '../../../packages/kiti/components/helpers/Line'
import PeriodFilter from './filters/PeriodFilter'
import TabsMenu from './tabs/TabsMenu'
import { useTranslation } from 'react-i18next'

const ControlBar = () => {
  const { t } = useTranslation('dashboard')
  const screen = useDashActiveTab()
  const addNewWidget = useOpenSelectWidgetTypeModal()
  const canSetup = useSessionPermission('setupDashboard')

  const { isFullScreen } = useFullScreenState()
  const { editing } = useForm()
  const { handleChange } = useFormState()
  const toggleEditing = () => handleChange('editing', !editing)

  const hasFilter = !isEmpty(omit(['date'], useFilter()))
  const [isFiltering, setFiltering] = React.useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  return (
    <>
      <Grid justify="space-between" align="center" gap={0.75}>
        <Col>
          <TabsMenu />
        </Col>

        <Col flex={1} />

        {!editing ? (
          <>
            <HideOnFullScreen>
              <Col>
                <PeriodFilter />
              </Col>

              <Col>
                <Line vertical height={1} color="light4" />
              </Col>

              <Col>
                <IconText
                  iconRight="RiFilter3Fill"
                  iconSize={1.2}
                  color="dark3"
                  label={t('filter')}
                  bold
                  onClick={toggleFilter}
                />
              </Col>

              {canSetup && (
                <>
                  <Col>
                    <Line vertical height={1} color="light4" />
                  </Col>

                  <Col>
                    <Icon name="RiSettings3Line" size={1.2} color="dark3" onClick={toggleEditing} />
                  </Col>
                </>
              )}
            </HideOnFullScreen>

            <ShowOnFullScreen>
              <Col>
                <Icon name="IoPlayOutline" size={1.2} color="dark3" />
              </Col>
            </ShowOnFullScreen>

            {/*
              <Col>
                <FullScreenIcon />
              </Col>
            )*/}
          </>
        ) : (
          <>
            <Col>
              <IconButton
                label={t('addWidget')}
                icon="BsPlus"
                size="xsmall"
                bold
                transparent
                onClick={() => addNewWidget({ screenId: screen.id })}
              />
            </Col>
            <Col>
              <Button size="small" transparent color="dark3" onClick={toggleEditing}>
                {t('closeEdit')}
              </Button>
            </Col>
          </>
        )}
      </Grid>

      <FiltersBar open={isFiltering} onClose={hideFilter} />
    </>
  )
}

export default ControlBar
